import { render, staticRenderFns } from "./modal-insurance-cancel.vue?vue&type=template&id=4d422372&"
import script from "./modal-insurance-cancel.vue?vue&type=script&lang=js&"
export * from "./modal-insurance-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports